module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026-2027.1789545008192.jpg";